import { useQuery } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

export const priceSummaryJobQueryKeys = {
  all: ['priceSummaryJobs'] as const,
  recent: (userId?: string) => [...priceSummaryJobQueryKeys.all, 'recent', userId] as const,
};

export function useGetRecentPriceSummaryJobs({ enabled = true, userId }: { enabled?: boolean; userId?: string } = {}) {
  return useQuery({
    queryKey: priceSummaryJobQueryKeys.recent(userId),
    queryFn: () => PriceParrotService.getPriceSummaryJobs({ limit: 50, user_id: userId }),
    select: (response) => response.data,
    enabled,
  });
}
